// Content series (feature 4). "None" is intentionally excluded from public lists.
export const SERIES = [
  { name: "Time Out", label: "Short Film" },
  { name: "Penalty", label: "Op-Ed" },
  { name: "The Mental Rep", label: "Series" },
  { name: "After the Whistle", label: "Podcast" },
  { name: "Instant Replay", label: "Series" },
  { name: "Crossed Signals", label: "Series" },
  { name: "Mic'd Up", label: "Series" },
  { name: "Hot Take Huddle", label: "Debate" },
];

export const seriesSlug = (name) =>
  (name || "").toLowerCase().replace(/'/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const seriesFromSlug = (slug) =>
  SERIES.find((s) => seriesSlug(s.name) === slug)?.name || null;
